import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCover from "@/pages/home/components/HeroCover";
import BriefingFeed from "@/pages/home/components/BriefingFeed";
import TopicWall from "@/pages/home/components/TopicWall";
import CollectionIndex from "@/pages/home/components/CollectionIndex";
import StoryGrid from "@/pages/home/components/StoryGrid";
import HotRanking from "@/pages/home/components/HotRanking";
import TipBox from "@/pages/home/components/TipBox";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <SiteHeader />
      <main>
        <HeroCover />
        <BriefingFeed />
        <TopicWall />
        <CollectionIndex />
        <StoryGrid />
        <HotRanking />
        <TipBox />
      </main>
      <SiteFooter />
    </div>
  );
}